module.exports = __webpack_public_path__ + "static/media/bgame.2ac0648b.svg";